import { Link } from 'react-router-dom'
import './AlertCard.css'

const AlertCard = ({ alert }) => {
  const getUrgencyClass = (urgency) => {
    return `alert-urgency-${urgency}`
  }

  const getTypeIcon = (type) => {
    const icons = {
      error: '🚨',
      warning: '⚠️',
      info: 'ℹ️'
    }
    return icons[type] || '📌'
  }

  return (
    <Link to={alert.action} className={`alert-card ${getUrgencyClass(alert.urgency)}`}>
      <div className="alert-icon">{getTypeIcon(alert.type)}</div>
      <div className="alert-content">
        <h4 className="alert-title">{alert.title}</h4>
        <p className="alert-message">{alert.message}</p>
        <span className="alert-order-number">{alert.orderNumber}</span>
      </div>
      <div className="alert-urgency-indicator">
        <div className={`urgency-dot urgency-${alert.urgency}`}></div>
      </div>
    </Link>
  )
}

export default AlertCard

